import { Http } from "../../utilities/axios/http";

export class UploadService {
  static uploadFile = async (value: any) => {
    try {
      return await Http.post(`/api/file_media`, value);
    } catch (error) {
      return error;
    }
  };
  static uploadImage = async (value: any) => {
    try {
      return await Http.post(`/api/image_media`, value);
    } catch (error) {
      return error;
    }
  };
}
